// Network metrics count total bytes since the device booted, so each reading
// is always higher than the last unless the device restarted. Summing only
// the positive steps between consecutive readings gives us the actual traffic
// in the selected time window, while skipping resets.
import { DeviceMetricsDataPoint } from '@/types/device'

export const computeNetworkDelta = (
  points: DeviceMetricsDataPoint[]
): number | null => {
  if (points.length < 2) return null

  const sorted = points.slice().sort((a, b) => a.ts - b.ts)

  return sorted.slice(1).reduce((sum, p, i) => {
    const delta = parseFloat(p.value) - parseFloat(sorted[i].value)
    return delta > 0 ? sum + delta : sum
  }, 0)
}
